import script from "./JiraAppLicenseBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./JiraAppLicenseBanner.vue?vue&type=script&setup=true&lang=js"

import "./JiraAppLicenseBanner.vue?vue&type=style&index=0&id=29d63d71&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29d63d71"]])

export default __exports__